import { render, staticRenderFns } from "./PropertyTitleTimePickerLoadingPlaceholder.vue?vue&type=template&id=83ef4e4a&"
import script from "./PropertyTitleTimePickerLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PropertyTitleTimePickerLoadingPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ef4e4a')) {
      api.createRecord('83ef4e4a', component.options)
    } else {
      api.reload('83ef4e4a', component.options)
    }
    module.hot.accept("./PropertyTitleTimePickerLoadingPlaceholder.vue?vue&type=template&id=83ef4e4a&", function () {
      api.rerender('83ef4e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertyTitleTimePickerLoadingPlaceholder.vue"
export default component.exports